module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB/SURBVHgB5ZQxDoAgDEW/xoPgzYyDh3Iw3kxuojjooLSFKonCWxhK074OH/g7FVfs+mFxjwGPnaexpYo1eAxk2D8NAnAbek2d4Sq0igaPOTcL2SaGwzq5wY3dRGND9SU3+MaAq37MGQs5UdkDVGFHhZ+PjE/0Vrr6DCz0WGTHBpKuJjzbUp52AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/assets/delete-gray.png
// module id = yJ2U
// module chunks = 1